import { get, isEmpty, noop } from "lodash-es";
import { call, put, takeLatest } from "redux-saga/effects";
import { setError } from "../reducers/error";
import { setLoader } from "../reducers/loader";
import { getAccountSummary } from "../../apis/common";
import { getCampaignData } from "../../utils/app/functions";
import {
  setBankList,
  setCampaign,
  setKyc,
  setNps,
  setReferral,
  setUser,
  setSubscriptionStatus,
  fetchSummary,
  updateBankList,
} from "../reducers/app";
import { update_banklist } from "../../apis/app";
import { setIsFoDisclosureRequired } from "../reducers/foDisclosure";

export default function* sagaFetchSummary() {
  yield takeLatest(fetchSummary.toString(), handleFetchSummary);
  yield takeLatest(updateBankList.toString(), handleUpdateBankList);
}

function* handleFetchSummary({ payload }) {
  const { Api, screen, token, data, sagaCallback = noop } = payload;
  yield put(setLoader({ screen, isPageLoading: true }));
  yield put(
    setError({
      screen,
      isFetchFailed: false,
      isUpdateFailed: false,
      message: "",
    })
  );
  try {
    const response = yield call(getAccountSummary, Api, data, token);
    const kyc = get(response, "data.kyc.kyc.data", {});
    const user = get(response, "data.user.user.data", {});
    const campaigns = get(response, "data.campaign.user_campaign.data", []);
    const campaignData = getCampaignData(campaigns);
    const nps = get(response, "data.nps.nps_user.data", {});
    const bankList = get(response, "data.bank_list.bank_list.data", []);
    const referral = get(response, "data.referral", {});
    const isFoDisclosureRequired = get(response, "fo_disclosure_required", false);
    const subscriptionStatus = get(
      response,
      "data.equity.subscription_status.data",
      {}
    );
    if (!isEmpty(kyc)) {
      yield put(setKyc(kyc));
    }
    if (!isEmpty(user)) {
      yield put(setUser(user));
    }
    if (!isEmpty(campaignData)) {
      yield put(setCampaign(campaignData));
    }
    if (!isEmpty(nps)) {
      yield put(setNps(nps));
    }
    if (!isEmpty(bankList)) {
      yield put(setBankList(bankList));
    }
    if (!isEmpty(referral)) {
      yield put(setReferral(referral));
    }
    if (!isEmpty(subscriptionStatus)) {
      yield put(setSubscriptionStatus(subscriptionStatus));
    }
    if (isFoDisclosureRequired) {
      yield put(setIsFoDisclosureRequired(isFoDisclosureRequired));
    }
    const appData = {
      kyc,
      user,
      nps,
      bankList,
      referral,
      campaignData,
      subscriptionStatus,
    };
    yield call(sagaCallback, response, appData);
  } catch (err) {
    console.log("error is", err);
    yield put(setError({ screen, isFetchFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleUpdateBankList({ payload }) {
  const { Api, screen, token, data, sagaCallback = noop } = payload;
  yield put(setLoader({ screen, isButtonLoading: true }));
  yield put(
    setError({
      screen,
      isFetchFailed: false,
      isUpdateFailed: false,
      message: "",
    })
  );
  try {
    const response = yield call(update_banklist, Api, data, token);
    yield put(setBankList([]));
    yield call(sagaCallback, response);
  } catch (err) {
    console.log("error is", err);
    yield put(setError({ screen, isUpdateFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isButtonLoading: false }));
  }
}
